import { useEffect } from 'react'

export default function AppPreventNavigation() {

  useEffect(() => {
    let isSubscribed = true
    if (isSubscribed) window.onbeforeunload = () => true
    return () => {
      window.onbeforeunload = () => undefined
      isSubscribed = false
    }
  }, [])

  return null
}
